import { useLang } from "@/i18n/LanguageProvider";
import { ALL_LANGS, LANG_META, pickLang, STRINGS, type Lang } from "@/i18n/strings";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Globe } from "lucide-react";

export const LanguageSwitcher = ({ className = "" }: { className?: string }) => {
  const { lang, setLang } = useLang();
  const aria = pickLang(STRINGS.langSwitcher.ariaLabel, lang);
  const current = LANG_META[lang];

  return (
    <DropdownMenu>
      <DropdownMenuTrigger
        aria-label={`${current.code.toUpperCase()} — ${aria}`}
        className={`inline-flex items-center gap-1.5 rounded-full bg-secondary/60 px-3 py-1.5 text-xs font-medium hover:bg-secondary transition ${className}`}
      >
        <Globe size={14} />
        <span className="uppercase">{current.code}</span>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="max-h-[60vh] overflow-y-auto min-w-[180px]">
        {ALL_LANGS.map((l: Lang) => {
          const m = LANG_META[l];
          const active = l === lang;
          return (
            <DropdownMenuItem
              key={l}
              onSelect={() => setLang(l)}
              className={`cursor-pointer ${active ? "bg-secondary/60 font-semibold" : ""}`}
            >
              <span className="uppercase text-[10px] w-7 text-muted-foreground">{m.code}</span>
              <span>{m.nativeName}</span>
            </DropdownMenuItem>
          );
        })}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default LanguageSwitcher;
